export const FETCH_LIVE_WELD_STATUS_SAGA = "FETCH_LIVE_WELD_STATUS_SAGA";
export const FETCH_LIVE_WELD_STATUS_SUCCESS = "FETCH_LIVE_WELD_STATUS_SUCCESS";
export const FETCH_LIVE_WELD_STATUS_FAILURE = "FETCH_LIVE_WELD_STATUS_FAILURE";
export const START_WELD_STATUS_LOADER = "START_WELD_STATUS_LOADER";

export const CHANGE_WELD_NUMBER = "CHANGE_WELD_NUMBER";
export const CHANGE_WELD_NUMBER_WITH_UID = "CHANGE_WELD_NUMBER_WITH_UID";
